const StudyingIcon = () => {
  return (
    <svg viewBox="0 0 18 15.231">
      <g transform="translate(-31.372 -63.156)">
        <path
          d="M40.372,63.156a1.383,1.383,0,1,0,1.383,1.383A1.383,1.383,0,0,0,40.372,63.156Zm-.53,4.15a2.082,2.082,0,0,0-1.856,1.146l-1,2a.694.694,0,0,0,.13.8L38.2,72.339l-.249.5H36.125l-.511-3.555a.692.692,0,0,0-.683-.594H32.672a.7.7,0,0,0-.686.594l-.57,4a.692.692,0,0,0,.657.935V77.68a.692.692,0,1,0,1.383,0V74.222h4.255l.6,3.572a.691.691,0,0,0,1.372-.146V74.222h1.383v3.415a.691.691,0,0,0,1.372.157l.6-3.572h4.255V77.68a.692.692,0,1,0,1.383,0V74.222a.7.7,0,0,0,.575-.294.688.688,0,0,0,.081-.637l-.573-4.007a.692.692,0,0,0-.683-.594H45.813a.7.7,0,0,0-.686.594l-.508,3.555H42.792l-.249-.5,1.083-1.086a.694.694,0,0,0,.13-.8l-1-2A2.082,2.082,0,0,0,40.9,67.306Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default StudyingIcon;
